// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgCheckDone = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill={props.color ?? 'currentColor'}
      d="M6 13.5c-.3 0-.5-.1-.7-.3L.8 8.7c-.4-.4-.4-1 0-1.4s1-.4 1.4 0L6 11.1l7.8-7.8c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-8.5 8.5c-.2.3-.4.3-.7.3"
    />
  </svg>
)
export default SvgCheckDone
